/* LIBRAIRIES */
import React, { Fragment, useState } from 'react';

/* CONTEXT */
import { useUserContext } from '../../useContext';

/* ASSETS */
import DeleteBtn from '../../Assets/DeleteBtn/DeleteBtn';
import ModifyBtn from '../../Assets/ModifyBtn/ModifyBtn';
import ViewBtn from '../../Assets/ViewBtn/ViewBtn';

/* MUI */
import Box from '@mui/material/Box';
import { DataGrid, gridClasses, GridToolbarContainer, GridToolbarQuickFilter } from '@mui/x-data-grid';
import { alpha, styled } from '@mui/material/styles';
import { useMediaQuery } from '@mui/material';

/* CSS */ 
import './DataGridUsers.css';

//-----------------------------STRIPED DATA-GRUD-----------------------------//
//--------------------------------------------------------------------------//
const ODD_OPACITY = 0.2;

const StripedDataGrid = styled(DataGrid)(({ theme }) => ({
  [`& .${gridClasses.row}.even`]: {
    backgroundColor: theme.palette.grey[200],
    '&:hover, &.Mui-hovered': {
      backgroundColor: alpha(theme.palette.primary.main, ODD_OPACITY),
      '@media (hover: none)': {
        backgroundColor: 'transparent',
      },
    },
    '&.Mui-selected': {
      backgroundColor: alpha(
        theme.palette.primary.main,
        ODD_OPACITY + theme.palette.action.selectedOpacity,
      ),
      '&:hover, &.Mui-hovered': {
        backgroundColor: alpha(
          theme.palette.primary.main,
          ODD_OPACITY +
            theme.palette.action.selectedOpacity +
            theme.palette.action.hoverOpacity,
        ),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: alpha(
            theme.palette.primary.main,
            ODD_OPACITY + theme.palette.action.selectedOpacity,
          ),
        },
      },
    },
  },
}));

//-----------------------------SEARCH FILTER-----------------------------//
//----------------------------------------------------------------------//
function QuickSearchToolbar() {
  return (
    <GridToolbarContainer sx={{ p: '5px 10px' }}>
      <GridToolbarQuickFilter placeholder='Rechercher'/>
    </GridToolbarContainer>
  );
}

export default function QuickFilteringCustomizedGrid({ users }) {

    const [pageSize, setPageSize] = useState(100);
    const isMobile = useMediaQuery('(max-width: 500px)'); // Condition pour écran mobile
    const { userRole } = useUserContext(); // récupération de la valeur userRole depuis le contexte

    //-----------------------------COLUMN SETTINGS-----------------------------//
//------------------------------------------------------------------------//
const columns = [
  { 
    field: 'role', 
    headerName: 'Status', 
    flex: 1,
    renderCell: (params) => {
        const role = params.row.role && params.row.role
        let color = "";
        if (role === "admin") {
            color = "#8530d1";
        } else if (role === "collaborateur") {
            color = "#0066cc";
        } else {
            color = "#3A9D23"
        }

        return (<div style={{backgroundColor: color, padding: "5px", color: "white", borderRadius: "5px"}}>{role}</div>)
    }
  }, 
  { field: 'firstName', headerName: "Nom", flex: 1.5,
        renderCell: (params) => (
            <div>{params.row.firstName} {params.row.name}</div>
        )
    },
  { field: 'phone', headerName: 'Téléphone', flex: 1 },
  { field: 'email', headerName: 'Email', flex: 2 },
  {
    field: 'Actions',
    headerName: 'Actions', 
    flex: 1,
    renderCell: (params) => {
        return (
            <div style={{display: 'flex', justifyContent: 'center', gap: "5px", width: "100%" }}>
                <div>
                    <ViewBtn id={params.row.userId} />
                </div> 
                { userRole === 'admin' && 
                    <div>
                        <ModifyBtn id={params.row.userId} user={params.row}/>
                    </div>
                }
                { userRole === 'admin' && 
                    <div>
                        <DeleteBtn id={params.row.userId} />
                    </div>
                }
        </div> 

        )
    }
  } 
];

//-----------------------------------------------------

    return (
        <Fragment>
        { users !== undefined &&
            <Box sx={{ height: "100%", width: "100%", position: "relative"}}>
              <StripedDataGrid
                  getRowClassName={(params) =>
                    params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
                  }
                  sx={{ color: 'black', borderColor: '#ccc' }}
                  rows={users}
                  getRowId={(row) => row.userId}
                  columns={isMobile ? columns.filter((col) => col.field !== 'name' && col.field !== 'phone' && col.field !== 'email') : columns}
                  disableColumnFilter
                  disableColumnSelector
                  disableDensitySelector
                  pageSize={pageSize}
                  onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                  rowsPerPageOptions={[10, 20, 50, 100]}
                  components={{ Toolbar: QuickSearchToolbar}} 
              />
            </Box>
        }
        </Fragment>
    );
}